import React from 'react';
import {cartStore} from 'stores/cart.store';
import {authStore} from 'stores/auth.store';

export const storesContext = React.createContext({
  authStore: authStore,
  cartStore: cartStore,
});
